import type React from "react";

interface SectionTitleProps {
  children: React.ReactNode;
}

export function SectionTitle({ children }: SectionTitleProps) {
  return <h2 className="text-5xl font-black tracking-tight">{children}.</h2>;
}
